/**
 * BigBerkeyWaterFilters.com - Step Numbers
 * Version: FINAL v7 - Require minimum 2 sections
 */

(function() {
  'use strict';

  function createStepBadge(stepNumber) {
    const badge = document.createElement('span');
    badge.className = 'bbwf-step-number';
    badge.textContent = `STEP ${stepNumber}`;
    return badge;
  }

  function hasStepBadge(element) {
    return element.querySelector('.bbwf-step-number') !== null;
  }

  function getElementPosition(element) {
    return element.getBoundingClientRect().top + window.scrollY;
  }

  function injectStepNumbers() {
    console.log('=== BBWF Step Numbers ===');
    
    let sections = [];

    // 1. Find all fieldset legends
    const productForm = document.querySelector('.product-form, .product__info-wrapper, [data-product-form]');
    
    if (productForm) {
      const legends = productForm.querySelectorAll('fieldset legend');
      legends.forEach(legend => {
        if (!hasStepBadge(legend)) {
          const text = legend.textContent.toLowerCase();
          if (!text.includes('quantity')) {
            sections.push({ 
              element: legend, 
              text: legend.textContent.trim(),
              position: getElementPosition(legend)
            });
          }
        }
      });
    }

    // 2. Find the accessories heading
    const accessoriesHeading = document.querySelector('.product-checkbox-options__heading, h3.product-checkbox-options__heading');
    
    if (accessoriesHeading && !hasStepBadge(accessoriesHeading)) {
      sections.push({ 
        element: accessoriesHeading, 
        text: accessoriesHeading.textContent.trim(),
        position: getElementPosition(accessoriesHeading)
      });
    }

    console.log(`Found ${sections.length} sections`);

    // Require minimum 2 sections to activate
    if (sections.length < 2) {
      console.log('Only 1 section found, minimum 2 required. Skipping step numbers.');
      return;
    }

    // Sort by position (top to bottom)
    sections.sort((a, b) => a.position - b.position);

    sections.forEach((s, i) => {
      console.log(`  ${i + 1}. "${s.text}"`);
    });

    // Add step badges
    let stepNumber = 1;
    sections.forEach(section => {
      const badge = createStepBadge(stepNumber);
      section.element.insertBefore(badge, section.element.firstChild);
      console.log(`✓ STEP ${stepNumber}: "${section.text.substring(0, 40)}"`);
      stepNumber++;
    });

    console.log(`=== Added ${stepNumber - 1} step badges ===`);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectStepNumbers);
  } else {
    injectStepNumbers();
  }

  window.BBWF_StepNumbers = {
    reinject: injectStepNumbers,
    version: 'FINAL-v7'
  };
  
  console.log('BBWF Step Numbers FINAL-v7 loaded');
})();
/**
 * BBWF Rebuy plan shim (added Oct 21 2026, Phoenix systems launch)
 * Rebuy's server copy of a new product can have no Recharge selling plans, so the
 * Smart Cart shows no interval dropdown on that line. This fills the plans in from
 * /products/<handle>.js for any cart line that has a selling plan but no plan data.
 * Lines Rebuy already knows (Phoenix filters etc) are untouched.
 */
(function(){
  if (window.__bbwfPlanShim) return; window.__bbwfPlanShim = true;
  var cache = {};
  function getJSON(handle){
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + handle + '.js').then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; });
    }
    return cache[handle];
  }
  function patchItem(item){
    var p = item && item.product;
    if (!p || !item.selling_plan_allocation) return Promise.resolve(false);
    if (p.selling_plan_groups && p.selling_plan_groups.length) return Promise.resolve(false);
    if (!p.handle) return Promise.resolve(false);
    return getJSON(p.handle).then(function(pj){
      if (!pj || !pj.selling_plan_groups || !pj.selling_plan_groups.length) return false;
      var groups = pj.selling_plan_groups.map(function(g){
        return {
          id: g.id, name: g.name, description: '', appId: g.app_id,
          variants: pj.variants.map(function(v){ return v.id; }),
          options: g.options,
          selling_plans: g.selling_plans.map(function(s){
            return { id: s.id, name: s.name, description: '', position: 1, options: s.options,
              price_adjustments: [{ order_count: null, position: 0, value_type: 'percentage', value: '0.00' }] };
          })
        };
      });
      groups.sort(function(a, b){
        var n = function(x){ var m = String(x.name).match(/(\d+)/); return m ? +m[1] : 0; };
        return n(a) - n(b);
      });
      var plans = [];
      groups.forEach(function(g){ plans = plans.concat(g.selling_plans); });
      var names = plans.map(function(s){ return s.name; });
      p.selling_plan_groups = groups;
      p.has_subscription = true;
      p.is_subscription_only = !!pj.requires_selling_plan;
      p.subscription_discount_type = 'percentage';
      p.subscription_discount_amount = '0.00';
      p.subscription_frequencies = names;
      p.subscription_frequency = item.selling_plan_allocation.selling_plan.name;
      (p.variants || []).forEach(function(v){
        var sv = null;
        pj.variants.forEach(function(x){ if (x.id == v.id) sv = x; });
        v.selling_plans = plans;
        v.subscription_frequencies = names;
        v.selling_plan_allocations = ((sv && sv.selling_plan_allocations) || []).map(function(a){
          return { price_adjustments: [{ position: 1, price: a.price }], price: a.price,
            compare_at_price: a.compare_at_price || a.price, per_delivery_price: a.per_delivery_price,
            selling_plan_id: a.selling_plan_id, selling_plan_group_id: a.selling_plan_group_id };
        });
      });
      try { item.product = Object.assign({}, p); } catch(e) {}
      return true;
    });
  }
  function months(x){ var m = String(x && x.name !== undefined ? x.name : x).match(/(\d+)/); return m ? +m[1] : 0; }
  function sortItem(item){
    var p = item && item.product;
    if (!p || !p.subscription_frequencies || p.subscription_frequencies.length < 2) return;
    var f = p.subscription_frequencies;
    var sorted = f.slice().sort(function(a, b){ return months(a) - months(b); });
    if (sorted.join('|') === f.join('|')) return;
    var byMonths = function(a, b){ return months(a) - months(b); };
    p.subscription_frequencies = sorted;
    if (p.selling_plan_groups) p.selling_plan_groups = p.selling_plan_groups.slice().sort(byMonths);
    (p.variants || []).forEach(function(v){
      if (v.subscription_frequencies) v.subscription_frequencies = v.subscription_frequencies.slice().sort(byMonths);
      if (v.selling_plans) v.selling_plans = v.selling_plans.slice().sort(byMonths);
    });
    try { item.product = Object.assign({}, p); } catch(e) {}
  }
  function run(){
    var sc = window.Rebuy && window.Rebuy.SmartCart;
    if (!sc || typeof sc.items !== 'function') return;
    var items = [];
    try { items = sc.items() || []; } catch(e) { return; }
    items.forEach(function(i){ sortItem(i); patchItem(i); });
  }
  function runSoon(){ run(); setTimeout(run, 300); setTimeout(run, 1200); }
  ['rebuy:smartcart.ready', 'rebuy:cart.ready', 'rebuy:cart.change', 'rebuy:cart.add', 'rebuy:smartcart.show', 'rebuy:smartcart.line-item-increase', 'rebuy:smartcart.line-item-decrease']
    .forEach(function(ev){ document.addEventListener(ev, runSoon); window.addEventListener(ev, runSoon); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', runSoon); else runSoon();
})();